import { useMemo, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { RiskLevel } from '../../../../components/utilities/RiskLevel'
import { toLocaleUTCDateString } from '../../../../components/common/time/timeHelper'
import { DataGridComponent } from '../../../../components/common/datagrid/DataGridComponent'
import { updateKybNotificationsV2Filters } from '../../../../features/kybNotificationsV2/kybNotificationsV2Slice'
import { useGetKybNotificationsV2Query } from '../../../../services/guenoApi'
import { Link as ReactRouterLink } from 'react-router-dom'
import { Link } from '@mui/material'
import { Flags } from '../../../../components/common/flag/flags'

export const NotificationsV2Datatable = ({ type, tableKey }) => {
  const { t } = useTranslation(['common'])
  const dispatch = useDispatch()
  const queryState = useSelector((state) => state.kybNotificationsV2.filters)
  const { limit, page, fromDate } = queryState

  const [localPage, setLocalPage] = useState(page)
  const [rowsPerPage, setRowsPerPage] = useState(limit)

  const { data, isFetching } = useGetKybNotificationsV2Query({
    limit: rowsPerPage,
    offset: rowsPerPage * localPage,
    page: localPage,
    type,
    ...(fromDate && { fromDate }),
  })

  const columns = useMemo(
    () => [
      /*       {
        field: '_id',
        headerName: 'ID',
        flex: 1.5,
        renderCell: (params) => <Typography variant="number">{params.row._id}</Typography>,
      }, */
      {
        field: 'name',
        headerName: t('common:name'),
        flex: 3,
        renderCell: ({ row }) => (
          <Link
            component={ReactRouterLink}
            title={row.kyb?._id}
            to={`/${type === 'PERSON' ? 'kyc' : 'kyb'}/${row?.countryCode ?? 'BR'}/detail/${row.kyb}`}
          >
            {`${row.name} (${row.documentNumber})`}
          </Link>
        ),
      },
      {
        field: 'documentType',
        headerName: t('common:documentType'),
        flex: 1.5,
      },
      {
        field: 'countryCode',
        headerName: t('common:country'),
        flex: 1,
        renderCell: (params) => {
          return params.row.countryCode ? Flags(params.row.countryCode) : '---'
        },
      },
      {
        field: 'riskLevel',
        headerName: t('common:riskLevel'),
        flex: 1,
        renderCell: (params) => (params.row.riskLevel ? <RiskLevel type={params.row.riskLevel} /> : ''),
      },
      {
        field: 'updatedAt',
        headerName: t('common:updatedAt'),
        flex: 2,
        renderCell: (params) => toLocaleUTCDateString(params.row.updatedAt),
      },
      {
        field: 'queryType',
        headerName: t('common:pointOfData'),
        flex: 2,
      },
    ],
    [],
  )

  const handleChangePage = (_, newPage) => {
    setLocalPage(newPage)
  }

  const handleChangeRowsPerPage = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage)
    setLocalPage(0)
  }

  useEffect(() => {
    dispatch(
      updateKybNotificationsV2Filters({
        ...queryState,
        limit: rowsPerPage,
        page: localPage,
        offset: rowsPerPage * localPage,
      }),
    )
  }, [rowsPerPage, localPage])

  return (
    <DataGridComponent
      getRowId={(row) => row._id || row.id}
      rows={Array.isArray(data?.data) && data?.data.length !== 0 ? data?.data : []}
      columns={columns}
      count={data?.pagination?.totalElements || 0}
      page={localPage}
      rowsPerPage={rowsPerPage}
      setPage={handleChangePage}
      setRowsPerPage={handleChangeRowsPerPage}
      setIsLoading={() => {}}
      setModalOpen={() => {}}
      tableKey={tableKey}
      isLoading={isFetching}
      showFilterButton={false}
    />
  )
}

export default NotificationsV2Datatable
